import { parse } from 'csv-parse/browser/esm/sync'

export const normalizeFileName = (fileName = '') => {
  const normalized = fileName
    .replaceAll(/[^\w\s.-]/g, '-')
    .replaceAll(/^[-_]+|[-_]+$/g, '')
    .toLowerCase()
    .replaceAll(/\s+/g, '-')
    .replaceAll(/[-_]+/g, '-')
    .slice(0, 250)

  return normalized
}

// Trigger a browser download for a Blob (e.g. a PDF/ZIP returned by the API as responseType 'blob').
export const downloadBlob = (blob, filename = 'download') => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const exportToCSV = (data, headers, filename = 'export') => {
  // Crear CSV content
  const csvContent = [
    // Headers
    headers.map((header) => `"${header.label}"`).join(','),
    // Data rows
    ...data.map((row) =>
      headers
        .map((header) => {
          const value = row[header.key] || ''
          return `"${String(value).replace(/"/g, '""')}"`
        })
        .join(',')
    )
  ].join('\n')

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `${filename}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}

export const readFileCSV = async (fileOrText, delimiter = ',') =>
  new Promise((resolve, reject) => {
    const parseText = (text) => {
      try {
        const csvData = parse(text, {
          delimiter,
          relax_column_count: true,
          trim: true
        })

        if (csvData?.[0]?.[0] === 'class_id' || csvData?.[0]?.[0] === 'code') {
          csvData.shift()
        }

        resolve({
          error: null,
          data: csvData
        })
      } catch (error) {
        console.error('Error parsing CSV:', error)
        reject({
          error: error?.message || 'Error reading file',
          data: null
        })
      }
    }

    if (!fileOrText) {
      reject({
        error: 'No file content provided',
        data: null
      })
      return
    }

    if (fileOrText instanceof Blob) {
      const reader = new FileReader()
      reader.onload = () => parseText(reader.result || '')
      reader.onerror = () =>
        reject({
          error: 'Error reading file',
          data: null
        })
      reader.readAsText(fileOrText)
      return
    }

    if (typeof fileOrText === 'string') {
      parseText(fileOrText)
      return
    }

    reject({
      error: 'Unsupported file input',
      data: null
    })
  })
